import {
  CreateMessageDTO,
  MessageResourceTypeMappings,
  ThreadResourceTypeMappings,
} from '@aa/nest/resource';
import { createAction, props } from '@ngrx/store';

const domainSlug = `[CHAT]`;
export const chatActions = {
  createNewThread: createAction(
    `${domainSlug} Create New Thread`,
    props<{
      orderCardId?: number;
      customerProfileId?: number;
      initialMessage?: Omit<CreateMessageDTO, 'threadId'>;
    }>(),
  ),
  connectToThread: createAction(
    `${domainSlug} Connect to Thread`,
    props<{ threadId: number }>(),
  ),
  connectToStaffThreads: createAction(`${domainSlug} Connect to Staff Threads`),
  connectToCustomerThreads: createAction(
    `${domainSlug} Connect to Customer Threads`,
  ),
  tryConnectToThreadForOrderCard: createAction(
    `${domainSlug} Connect to Thread for Order Card`,
    props<{ orderCardId: number }>(),
  ),
  tryConnectToThreadForCustomer: createAction(
    `${domainSlug} Connect to Thread for Customer`,
    props<{ customerId: number }>(),
  ),
  disconnectFromThread: createAction(
    `${domainSlug} Disconnect from Thread`,
    props<{ threadId: number }>(),
  ),
  sendMessage: createAction(
    `${domainSlug} Send Message`,
    props<{
      data: MessageResourceTypeMappings['createDTO'];
    }>(),
  ),
  markMessageAsRead: createAction(
    `${domainSlug} Mark Message as Read`,
    props<{
      messageId: number;
    }>(),
  ),
  markMessagesAsRead: createAction(
    `${domainSlug} Mark Messages as Read`,
    props<{
      messageIds: number[];
    }>(),
  ),
  threadConnected: createAction(
    `${domainSlug} Thread Connected`,
    props<{
      thread: ThreadResourceTypeMappings['resourceWithRelationsT'];
      messages: MessageResourceTypeMappings['resourceWithRelationsT'][];
    }>(),
  ),
  threadsConnected: createAction(
    `${domainSlug} Threads Connected`,
    props<{
      threads: ThreadResourceTypeMappings['resourceWithRelationsT'][];
    }>(),
  ),
  threadDisconnected: createAction(
    `${domainSlug} Thread Disconnecteed`,
    props<{
      threadId: number;
    }>(),
  ),
  messageAdded: createAction(
    `${domainSlug} Message Added`,
    props<{
      threadId: number;
      message: MessageResourceTypeMappings['resourceWithRelationsT'];
    }>(),
  ),
  messageUpdated: createAction(
    `${domainSlug} Message Updated`,
    props<{
      threadId: number;
      message: MessageResourceTypeMappings['resourceWithRelationsT'];
    }>(),
  ),
};
